export default function(ngModule) {
    ngModule.factory('Tracker', function(BaseClass,$q, $http, $injector) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function Tracker(attributes) {
            _.assign(this,attributes);
        }
        Tracker.modelName = 'Tracker';

        /**
         * Override the delete method so a user can't delete primary shop links
         *
         * @return {Promise} Resolves when deleted
         */
        Tracker.prototype.$delete = function() {
            let url = `/trackers/${ this.guid }`;
            return $injector.get('RelationAPI').get('ShopLink', this.guid, 'inverse')
                .then(relations => {
                    if(relations.length > 0) {
                        this.broadcastAPIMessage({
                            status: 900,
                            config: { url: url, method: 'DELETE' }
                        });
                        return $q.reject(new Error('Cant delete a primary tracker'));
                    }
                    Tracker.cached.remove(this.guid);
                    return $http.delete(url).then(response => {
                        this.broadcastAPIMessage(response);
                        return response;
                    }, error => {
                        this.broadcastAPIMessage(error);
                        return $q.reject(error);
                    });
                });
        };

        BaseClass.apply(Tracker);

        Tracker.validates({
            name: {
                required: true
            },
            shop_id: {
                required: true
            },
            type: {
                required: true,
                inclusion: {
                    in: [
                        'website',
                        'facebook',
                        'twitter',
                        'pinterest',
                        'linkedin',
                        'instagram',
                        'email',
                        'other'
                    ]
                }
            }
        });

        Tracker.configureAPIMessages({
            'DELETE /trackers/:shop_guid': {
                900: 'models.trackers.notice.deleteShopLinkDenied'
            }
        });

        Tracker.configureApi('/trackers/:guid', {
            queryAdmin: '/trackers/:status/:company',
            reinstate: '/trackers/:guid/reinstate'
        });
        Tracker.belongsTo('Shop', 'shop_id', 'guid', '/shop/^guid');
        Tracker.prototype.toString = function() { return this.name; };

        return Tracker;
    });
}
